import { render, staticRenderFns } from "./MAppointmentsList.vue?vue&type=template&id=f08e767a&scoped=true"
import script from "./MAppointmentsList.vue?vue&type=script&lang=ts"
export * from "./MAppointmentsList.vue?vue&type=script&lang=ts"
import style0 from "./MAppointmentsList.vue?vue&type=style&index=0&id=f08e767a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.37_css-loader@6.11.0_webpack@5.93.0__ejs@3.1.10_hoga_mqdlk73zogqfmm4uknw3a3yvy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08e767a",
  null
  
)

export default component.exports